import { Navigate, RouteObject } from 'react-router-dom';

import { mapRoutes } from './map/config';
import { profilesRoutes } from './profiles/config';
import { PROFILES_ROUTE } from './profiles/list';

export const UNKNOWN_ROUTE = '*';

export const HOME_AUTH_ROUTE = PROFILES_ROUTE;

// ROUTE WITH ID EXAMPLE
// export const COMPANY_ROUTE = '/company';
// export const COMPANY_WITH_ID_ROUTE = `${COMPANY_ROUTE}/:companyId`;
// export const getCompanyWithIdRoute = (id: string | number): string => `${COMPANY_ROUTE}/${id}`;

export type RouteConfig = RouteObject & {
  id?: string;
  permissions?: Record<string, unknown>;
  roles?: string[];
  children?: RouteConfig[];
};

export const initAuthRoutes = (roleModel: unknown) => {
  const routes: RouteObject[] = [
    { path: UNKNOWN_ROUTE, element: <Navigate replace to={HOME_AUTH_ROUTE} /> },
  ];

  const userHasNecessaryRole = (item: RouteConfig): boolean => {
    // return !!item.roles?.some((role: GLOBAL_ROLES) => {
    //   return roleModel.roles[role];
    // });

    return true;
  };
  const userHasNecessaryPermission = (item: RouteConfig): boolean => {
    // return Object.entries(item.permissions ?? {}).some(
    //   ([type, value]: [string, PERMISSION_DATA_VALUE_ENUM]): boolean => {
    //     return (
    //       (roleModel.permissions[type as PERMISSION_TYPE] === PERMISSION_DATA_VALUE_ENUM.WRITE &&
    //         value === PERMISSION_DATA_VALUE_ENUM.READ) ||
    //       roleModel.permissions[type as PERMISSION_TYPE] === value
    //     );
    //   },
    // );

    return true;
  };

  const initConfigRoutes = (elements: RouteConfig[]) => {
    elements.forEach((item: RouteConfig) => {
      //   const userHasRights = userHasNecessaryPermission(item) || userHasNecessaryRole(item);
      //   const routeDoesntRequireAnyRights = !item.roles && !item.permissions;
      //
      //   const userCanAccessRoute = userHasRights || routeDoesntRequireAnyRights;
      //
      //   if (userCanAccessRoute) {
      const filteredChildren = item.children?.filter((child: RouteConfig) => {
        //       const childHasRights = userHasNecessaryPermission(child) || userHasNecessaryRole(child);
        //       const childDoesntRequireAnyRights = !child.roles && !child.permissions;
        //
        //       return childHasRights || childDoesntRequireAnyRights;
        return true;
      });
      //
      routes.push({ path: item.path, children: filteredChildren, element: item.element });
      //   }
    });
  };

  initConfigRoutes([...profilesRoutes, ...mapRoutes]);

  return routes;
};
